const FIELD_LABEL_KEYS: { [normalizedKey: string]: string } = {
  firstname: 'FORMS.FNAME',
  lastname: 'FORMS.LNAME',
  email: 'FORMS.EMAIL',
  date: 'FORMS.BIRTHDAY',
  birthday: 'FORMS.BIRTHDAY',
  birthdate: 'FORMS.BIRTHDAY',
  dateofbirth: 'FORMS.BIRTHDAY',
  sex: 'FORMS.SEX',
  gender: 'FORMS.SEX',
  weight: 'FORMS.WEIGHT',
  height: 'FORMS.HEIGHT',
  // Pola pomiaru EKG/temperatury z mobilki (`add_ecg`, `add_temperature`) — bez
  // wpisu tutaj `humanizeFieldTerm` sklejał z klucza z bazy angielskie „Heart rate"/
  // „Temperature" niezależnie od języka interfejsu (błąd 452).
  heartrate: 'USER_DETAILS.PULSE',
  temperature: 'SOS_REQUEST.TEMPERATURE',
  phone: 'FORMS.PHONE-NUMBER',
  phonenumber: 'FORMS.PHONE-NUMBER',
  address: 'FORMS.ADDRESS',
  description: 'FORMS.DESCRIPTION',
  imei: 'FORMS.BAND.BAND-IMEI',
  phones: 'FORMS.BAND.ALARM-PHONE',
  simnumber: 'FORMS.BAND.SIM-NUMBER',
  nightmode: 'FORMS.BAND.NIGHT-MODE',
  whitelistnumbers: 'BACKEND.TRUSTED_NUMBERS',
  whitelistalias: 'BACKEND.WHITELIST_ALIAS',
  isalarmzone: 'BACKEND.ALARM_ZONE',
  alarmphones: 'BACKEND.ALARM_PHONES',
  notwearnotif: 'BACKEND.NO_WEAR',
  wearnotif: 'BACKEND.WEAR',
  sosnotif: 'BACKEND.SOS',
  fallnotif: 'BACKEND.FALL',
  fullbattnotif: 'BACKEND.FULL_BATTERY',
  lowbattnotif: 'BACKEND.LOW_BATTERY',
  zonenotif: 'BACKEND.ZONE_EXIT',
  namenotif: 'BACKEND.SEND_NAME',
  shrnotif: 'BACKEND.HEART_RATE_THRESHOLD',
  minhr: 'BACKEND.PRIVACY.HEART-RATE-RANGE',
  maxhr: 'BACKEND.PRIVACY.HEART-RATE-RANGE',
  ishr: 'BACKEND.PRIVACY.HEART-RATE-RANGE',
  minimumsat: 'BACKEND.PRIVACY.SATURATION-RANGE',
  minsat: 'BACKEND.PRIVACY.SATURATION-RANGE',
  issat: 'BACKEND.PRIVACY.SATURATION-RANGE',
  steps: 'BACKEND.PRIVACY.DAILY-STEPS-GOAL',
  dailysteps: 'BACKEND.PRIVACY.DAILY-STEPS-GOAL',
  measure: 'BACKEND.PRIVACY.MEASUREMENT-FREQUENCY',
  measurementinterval: 'BACKEND.PRIVACY.MEASUREMENT-FREQUENCY',
  isimmo: 'BACKEND.PRIVACY.IMMOBILITY-DETECTOR',
  isimmoalarm: 'BACKEND.PRIVACY.IMMOBILITY-ALARM',
  immothreshold: 'BACKEND.PRIVACY.IMMOBILITY-SENSITIVITY',
  immotime: 'BACKEND.PRIVACY.IMMOBILITY-FREQUENCY',
  fallsensitivity: 'SOS_REQUEST.FALL_DETECTOR_SENSITIVITY',
  stepnotification: 'FORMS.BAND.STEP-NOTIFICATION',
  timezone: 'COMMON.TIMEZONE',
  langband: 'COMMON.JEZYK_OPASKI',
  operatingmode: 'BACKEND.BAND_SCREENS',
  vol: 'BACKEND.VOLUME',
  pesel: 'BACKEND.PESEL',
  nightstart: 'BACKEND.FROM',
  nightstop: 'BACKEND.TO',
  aac: 'FORMS.BAND.AUTO-ANSWER-CALL',
  ivs: 'FORMS.BAND.INVERSE-SOS-FUNCTION',
  unit: 'DRUGS-VITAL.UNIT',
  amount: 'MEDICAL.QUANTITY',
  administrationmethod: 'MEDICAL.MEDICATION_TYPE',
  pill: 'MEDICAL.PILL',
  aerosol: 'MEDICAL.AEROSOL',
  syringe: 'MEDICAL.INJECTION',
  liquid: 'MEDICAL.LIQUID',
  cream: 'MEDICAL.OINTMENT',
  dose: 'MEDICAL.UNITS.DOSES',
  ml: 'MEDICAL.UNITS.MILLILITERS',
  g: 'MEDICAL.UNITS.GRAMS',
  configurationsynced: 'WORK-HISTORY.FIELD_CONFIGURATION_SYNCED',
  firmwareversion: 'WORK-HISTORY.FIELD_FIRMWARE_VERSION',
  oldimei: 'WORK-HISTORY.FIELD_OLD_IMEI',
  newimei: 'WORK-HISTORY.FIELD_NEW_IMEI',
  patientname: 'DASHBOARD.PATIENT',
  patientimei: 'FORMS.BAND.BAND-IMEI',
  alarmid: 'WORK-HISTORY.FIELD_ALARM_ID',
  fallcanceledat: 'WORK-HISTORY.FIELD_FALL_CANCELED_AT',
  observername: 'HEADER.OBSERVER',
  age: 'USER.AGE',
  tokensremoved: 'WORK-HISTORY.FIELD_TOKENS_REMOVED',
  initiated: 'WORK-HISTORY.FIELD_CALLS_INITIATED',
  failed: 'WORK-HISTORY.FIELD_FAILED',
  count: 'WORK-HISTORY.FIELD_CALLS_QUEUED',
  created: 'WORK-HISTORY.FIELD_CREATED',
  vaccine: 'BACKEND.HEALTH.VACCINATED',
  vaccinedate: 'BACKEND.HEALTH.LAST-VACCINE',
  covid: 'BACKEND.HEALTH.HAD-COVID',
  pozawale: 'BACKEND.HEALTH.AFTER-HEART-ATTACK',
  rozrusznik: 'BACKEND.HEALTH.PACEMAKER',
  nadcisnienie: 'BACKEND.HEALTH.HYPERTENSION',
  cukrzyca: 'BACKEND.HEALTH.DIABETES',
  astma: 'BACKEND.HEALTH.ASTHMA',
  alzheimer: 'BACKEND.HEALTH.ALZHEIMERS',
  arytmia: 'BACKEND.HEALTH.ARRHYTHMIA',
  tarczyca: 'BACKEND.HEALTH.THYROID',
  parkinson: 'BACKEND.HEALTH.PARKINSON',
  padaczka: 'BACKEND.HEALTH.EPILEPSY',
  aparat: 'BACKEND.HEALTH.HEARING-DEVICE',
  otherdiseases: 'BACKEND.HEALTH.OTHER-DISEASES',
  allergy: 'BACKEND.HEALTH.ALLERGIES',
  medicines: 'BACKEND.HEALTH.MEDICATIONS',
  moreinfo: 'BACKEND.HEALTH.ADDITIONAL-INFO',
  placefordocuments: 'BACKEND.HEALTH.DOCUMENT-LOCATION',
  placeformedicine: 'BACKEND.HEALTH.MEDICATION-LOCATION',
  placeformedicines: 'BACKEND.HEALTH.MEDICATION-LOCATION',
  walkingperson: 'BACKEND.HEALTH.MOBILITY',
  walkingnormal: 'DISEASE.WALKINGMETHODOPTION.WALKING_NORMAL',
  walkintogether: 'DISEASE.WALKINGMETHODOPTION.WALKIN_TOGETHER',
  walker: 'DISEASE.WALKINGMETHODOPTION.WALKER',
  wheelchair: 'DISEASE.WALKINGMETHODOPTION.WHEELCHAIR',
  laying: 'DISEASE.WALKINGMETHODOPTION.LAYING',
  hearing: 'BACKEND.HEALTH.HEARING',
  seeing: 'BACKEND.HEALTH.SIGHT',
  thinking: 'BACKEND.HEALTH.SPEECH',
  dobry: 'BACKEND.HEALTH.HEARINGOPTION.DOBRY',
  niedosluch: 'BACKEND.HEALTH.HEARINGOPTION.NIEDOSLUCH',
  gluchy: 'BACKEND.HEALTH.HEARINGOPTION.GLUCHY',
  niedowidzenie: 'BACKEND.HEALTH.SIGHTOPTION.NIEDOWIDZENIE',
  niewidomy: 'BACKEND.HEALTH.SIGHTOPTION.NIEWIDOMY',
  good: 'BACKEND.HEALTH.THINKINGOPTION.GOOD',
  depend: 'BACKEND.HEALTH.THINKINGOPTION.DEPEND',
  bad: 'BACKEND.HEALTH.THINKINGOPTION.BAD',
  male: 'BACKEND.MALE',
  female: 'BACKEND.FEMALE',
  lang: 'BACKEND.LANGUAGE_LABEL',
  city: 'FORMS.CITY',
  note: 'NOTES.NOTE',
  avatar: 'WORK-HISTORY.FIELD_AVATAR',
  smslimit: 'WORK-HISTORY.FIELD_SMS_LIMIT',
  displayname: 'WORK-HISTORY.FIELD_DISPLAY_NAME',
  immostart: 'WORK-HISTORY.FIELD_IMMO_START',
  immostop: 'WORK-HISTORY.FIELD_IMMO_STOP',
  latitude: 'WORK-HISTORY.FIELD_LATITUDE',
  longitude: 'WORK-HISTORY.FIELD_LONGITUDE',
  radius: 'BACKEND.ALARM_ZONE_RADIUS',
  interval: 'BACKEND.ALARM_ZONE_INTERVAL',
  channel: 'WORK-HISTORY.FIELD_CHANNEL',
  mobile: 'SETTINGS.PLATFORM_MOBILE',
  removedassignments: 'WORK-HISTORY.FIELD_REMOVED_ASSIGNMENTS',
  detached: 'WORK-HISTORY.FIELD_DETACHED',
  handleddate: 'AI-ANALYSIS.HANDLED-DATE',
  alarmtype: 'SOS_REQUEST.ALARM_TYPE',
  normal: 'SOS_REQUEST.ALARM_TYPE_OPTION_NORMAL',
  normalnotif: 'SOS_REQUEST.ALARM_TYPE_OPTION_DEFAULT',
  normal112: 'SOS_REQUEST.ALARM_TYPE_OPTION_112',
  technical: 'SOS_REQUEST.ALARM_TYPE_OPTION_TECHNICAL',
  learning: 'SOS_REQUEST.ALARM_TYPE_OPTION_LEARNING',
  advice: 'SOS_REQUEST.ALARM_TYPE_OPTION_ADVICE',
  authenticationtoken: 'WORK-HISTORY.FIELD_PUSH_TOKEN',
  blockingenabled: 'BACKEND.ALARM_PHONES_FEATURE',
  nameoffile: 'DOCUMENTS.NAME-OF-FILE',
  timestamp: 'WORK-HISTORY.FIELD_MEASURED_AT',
  takehours: 'USER.TAKE-HOUR',
  fields: 'BACKEND.SETTINGS',
  bandremovedhard: 'FORMS.BAND.REMOVE-BAND',
  bandwornhard: 'FORMS.BAND.SETUP-BAND',
  bandfullcharged: 'FORMS.BAND.FULL-BATT',
  bandcharged: 'FORMS.BAND.FULL-BATT',
  banddischarged: 'FORMS.BAND.LOW-BATT',
  bandhightemp: 'WORK-HISTORY.FIELD_NOTIFY_HIGH_TEMP',
  bandtemp: 'WORK-HISTORY.FIELD_NOTIFY_HIGH_TEMP',
  thresholdpulse: 'FORMS.BAND.HEARTRATE-RANGE',
  thresholdsaturation: 'FORMS.BAND.SAT-RANGE',
  thresholdsat: 'FORMS.BAND.SAT-RANGE',
  alarmsos: 'WORK-HISTORY.FIELD_NOTIFY_SOS',
  alarmfall: 'WORK-HISTORY.FIELD_NOTIFY_FALL',
  alarmimmo: 'WORK-HISTORY.FIELD_NOTIFY_IMMO',
  alarmzone: 'WORK-HISTORY.FIELD_NOTIFY_ZONE',
  notificationtype: 'WORK-HISTORY.FIELD_NOTIFICATION',
  action: 'SETTINGS.WH_ACTION',
  enable: 'WORK-HISTORY.VALUE_ENABLED',
  disable: 'WORK-HISTORY.VALUE_DISABLED',
  enableall: 'WORK-HISTORY.VALUE_ENABLED_ALL',
  disableall: 'WORK-HISTORY.VALUE_DISABLED_ALL',
  caregivername: 'WORK-HISTORY.FIELD_CAREGIVER',
  agentname: 'WORK-HISTORY.FIELD_REACH_AGENT',
  workhourscount: 'WORK-HISTORY.FIELD_WORK_HOURS_COUNT',
  carehourscount: 'WORK-HISTORY.FIELD_CARE_HOURS_COUNT',
  resetwholeweek: 'WORK-HISTORY.FIELD_WHOLE_WEEK',
  old: 'WORK-HISTORY.FIELD_PREVIOUS_HOURS',
  mode: 'WORK-HISTORY.FIELD_MODE',
  privilege: 'CAREGIVER.PERMISSIONS',
  extra: 'PERMISSION.EXTRA.NAME',
  allowedit: 'PERMISSION.ALLOWEDIT.NAME',
  hasaiaccess: 'PERMISSION.AIACCESS.NAME',
  aiaccess: 'PERMISSION.AIACCESS.NAME',
  deleteusers: 'PERMISSION.DELETEUSERS.NAME',
  addusers: 'PERMISSION.ADDUSERS.NAME',
  handleallalarms: 'PERMISSION.HANDLEALLALARMS.NAME',
  phoneprefix: 'WORK-HISTORY.FIELD_PHONE_PREFIX',
  restricted: 'WORK-HISTORY.FIELD_RESTRICTED',
  patients: 'ADMIN_PANEL.COL_PATIENTS',
  total: 'WORK-HISTORY.FIELD_TOTAL',
  updated: 'WORK-HISTORY.FIELD_UPDATED',
  all: 'WORK-HISTORY.FIELD_ALL_PATIENTS',
  assigned: 'COMMON.ASSIGNED_PATIENTS',
  removed: 'WORK-HISTORY.FIELD_REMOVED',
  continuousmeasurement: 'WORK-HISTORY.FIELD_CONTINUOUS_MEASUREMENT',
  enabled: 'BACKEND.ENABLED',
  status: 'COMMON.STATUS',
  activationdate: 'WORK-HISTORY.FIELD_ACTIVATION_DATE',
  spo2: 'USER_DETAILS.SATURATION',
  pulserate: 'USER_DETAILS.PULSE',
  pulse: 'USER_DETAILS.PULSE',
  systolic: 'USER_DETAILS.BP_SYSTOLIC',
  diastolic: 'USER_DETAILS.BP_DIASTOLIC',
  name: 'MEDICAL.MEDICATION_NAME',
  mygroup: 'PROJECT.PROJECT',
  day: 'COMMON.DAY_OF_WEEK',
  hours: 'CAREGIVER.WORK-HOURS',
  true: 'COMMON.YES',
  false: 'COMMON.NO',
};

export function toDescriptionFieldKey(term: string): string {
  const key = normalize(term);
  return (key && FIELD_LABEL_KEYS[key]) || null;
}

// Ustawienie powiadomienia web zapisuje z przedrostkiem `notify`, mobilka bez niego, a przełącznik z kropką.
function normalize(value: string): string {
  return (value || '').toString().trim().toLowerCase().replace(/[_\-\s.]/g, '').replace(/^notify/, '');
}

export function humanizeFieldTerm(term: string): string {
  if (!term || typeof term !== 'string') {
    return null;
  }
  const looksLikeField = /^[a-zA-Z][a-zA-Z0-9]*(_[a-zA-Z0-9]+)+$/.test(term)
    || /^[a-z][a-zA-Z0-9]*[A-Z][a-zA-Z0-9]*$/.test(term);
  if (!looksLikeField) {
    return null;
  }
  const words = term
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!words.length) {
    return null;
  }
  return words[0].charAt(0).toUpperCase() + words[0].slice(1) + (words.length > 1 ? ' ' + words.slice(1).join(' ') : '');
}
